import { render, staticRenderFns } from "./editCompany.vue?vue&type=template&id=0d3aa263&scoped=true&"
import script from "./editCompany.vue?vue&type=script&lang=ts&"
export * from "./editCompany.vue?vue&type=script&lang=ts&"
import style0 from "./editCompany.vue?vue&type=style&index=0&id=0d3aa263&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3aa263",
  null
  
)

export default component.exports